module.exports = __webpack_public_path__ + "static/img/A.0eb70e77.jpg";